import React, {useEffect, useRef, useState} from "react";
import '../styles/Quiz.css';
import {buildStyles, CircularProgressbar} from "react-circular-progressbar";

const ExamBox = ({onFinish, exam, participantId, extraData, examTakeStatus}) => {

    const [questions, setQuestions] = useState([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [score, setScore] = useState(0);
    const [showResults, setShowResults] = useState(false);
    // TODO commented out the because of the unused variable
    const [/*loading*/, setLoading] = useState(true);
    const [currentQuestion, setCurrentQuestion] = useState([]);
    const [examResult, setExamResult] = useState(null);
    const [score_progress, setScoreProgress] = useState(0);

    const prevExamId = useRef(exam.id);          // ilk render’da mevcut id’yi sakla

    if (prevExamId.current !== exam.id) {        // değişiklik oldu
        prevExamId.current = exam.id;              // ref'i güncelle

        // Yan etkiyi "render dışında" başlat:
        queueMicrotask(() => {                     // veya setTimeout(...,0)
            fetchExamResult(exam, participantId, extraData).then(r => console.log("fetchExamResult completed"));
        });
    }

    const fetchExamResult = async () => {

        if (examTakeStatus) {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/exam-results/exam-result-for-participant?examId=${exam.id}&participantId=${participantId}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                );

                if (!response.ok) {
                    console.error(`Failed to load exam result: ${response.status}`);
                    return;
                }

                const data = await response.json();
                setExamResult(data.score);
                //console.log("Exam result:", data);
                //console.log("participantId:", participantId);
                //console.log("exam.id:", exam.id);

            } catch (error) {
                console.error("Sınav sonucu yüklenemedi:", error);
            } finally {
                setLoading(false);
            }
        }
    };


    useEffect(() => {
        setScoreProgress(Math.round((score / questions?.length) * 100));
    }, [score, questions.length]);

    useEffect(() => {
        const fetchQuestions = async () => {
            setLoading(true);
            setQuestions([]);       // eski soruları temizle
            setCurrentQuestion(null); // eski current question’ı temizle

            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/exams/${exam.id}/sorted-questions`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                if (!response.ok) {
                    console.error(`Failed to load questions: ${response.status}`);
                    setLoading(false);
                    return;
                }

                const data = await response.json();
                setQuestions(data);
                setCurrentQuestion(data[0]);
            } catch (error) {
                console.error("Error fetching questions:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchQuestions().then(r => console.log("fetchQuestions completed"));
    }, [exam.id, extraData]);

    const handleAnswerSelection = (answer) => {
        setSelectedAnswer(answer);
        //console.log("selected answeer: " + answer);
    };

    const handleNextQuestion = async () => {
        const isCorrect = selectedAnswer === questions[currentQuestionIndex].correctAnswer;
        const newScore = score + (isCorrect ? 1 : 0);

        if (isCorrect) setScore(prev => prev + 1);
        //console.log("ex score:" + score , "t" + isCorrect, " score: " + newScore);

        const payload = {
            exam: {
                id: exam.id
            },
            participant: {
                id: participantId
            },
            question: {
                id: questions[currentQuestionIndex].id
            },
            selectedOption: selectedAnswer,
            answerTime: new Date().toISOString(),
            correct: selectedAnswer === questions[currentQuestionIndex].correctAnswer
        };

        //console.log("Sending payload:", JSON.stringify(payload));

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/exam-answers`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`Failed to save answer: ${response.statusText}`);
            }

            //console.log("Answer saved successfully!");
            //console.log("skor:", score);

            // Sonraki soruya geç
            if (currentQuestionIndex + 1 < questions.length) {
                setCurrentQuestionIndex(prev => prev + 1);
                setSelectedAnswer(null);
                setCurrentQuestion(questions[currentQuestionIndex + 1]);
            } else {
                onFinish(newScore, exam.id);
                setShowResults(true);
            }
        } catch (error) {
            console.error("Error saving answer:", error);
            alert("Cevap kaydedilirken bir hata oluştu!");
        }
    };

    const progress = Math.round(((currentQuestionIndex + 1) / questions.length) * 100);

    return (

        <div>
            <h2 align="center">{exam.examName}</h2>
            <div className="quiz-container">
                {(showResults || examTakeStatus) ? (
                    <div>
                        <h2 align="center">Sınav Tamamlandı!</h2>

                        {examResult ? (
                            <div>
                                <h2 align="center">Skorun: {examResult} Doğru / {questions.length} Soru</h2>
                                <h2 align="center">Başarı Oranı</h2>
                                <div style={{width: "30%", height: "30%", margin: "0 auto"}}>
                                    <CircularProgressbar
                                        value={Math.round((examResult / questions.length) * 100)}
                                        text={`${Math.round((examResult / questions.length) * 100)}%`}
                                        styles={buildStyles({
                                            textSize: "16px",
                                            pathColor: "#1d34a3",
                                            textColor: "#9eefad",
                                            trailColor: "#7a8ded",
                                        })}
                                    />
                                </div>
                            </div>
                        ) : (
                            <>
                                <p>Skorun: {score} Doğru / {questions.length} Soru</p>
                                <h2>Başarı Oranı</h2>
                                <p>{score_progress}%</p>
                                <div style={{width: "50%", height: "50%", margin: "0 auto"}}>
                                    <CircularProgressbar
                                        value={score_progress}
                                        text={`${score_progress}%`}
                                        styles={buildStyles({
                                            textSize: "16px",
                                            pathColor: "#1d34a3",
                                            textColor: "#ffffff",
                                            trailColor: "#7a8ded",
                                        })}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                ) : (
                    <div key={currentQuestionIndex}>

                        <div style={{background: '#eee', borderRadius: '5px', marginBottom: '10px'}}>
                            <div
                                style={{
                                    width: `${progress}%`,
                                    background: '#4caf50',
                                    height: '10px',
                                    borderRadius: '5px'
                                }}
                            />
                        </div>
                        <p>{progress}% tamamlandı</p>

                        <h2>{currentQuestionIndex + 1}. {currentQuestion?.question}</h2>
                        {currentQuestion && typeof currentQuestion === "object" && (

                            <ul>
                                {['op_1', 'op_2', 'op_3', 'op_4', 'op_5']
                                    .filter(option => currentQuestion[option])
                                    .map((option, index) => (
                                        <li key={index}>
                                            <button
                                                onClick={() => handleAnswerSelection(currentQuestion[option])}
                                                style={{
                                                    backgroundColor: selectedAnswer === currentQuestion[option]
                                                        ? "#add8e6"
                                                        : "white",
                                                    color: "black"
                                                }}
                                            >
                                                {currentQuestion[option]}
                                            </button>
                                        </li>
                                    ))}
                            </ul>
                        )}
                        <button
                            onClick={handleNextQuestion}
                            disabled={!selectedAnswer}
                        >
                            {currentQuestionIndex + 1 === questions.length ? "Sınavı Bitir" : "Sonraki Soru"}
                        </button>
                    </div>
                )}
            </div>

        </div>
    );
};
export default ExamBox;